module.exports = __webpack_public_path__ + "assets/img/7e10669e6924d1b3793d800e1c526408.png";